const DE: Record<number, string> = {
    0: 'Schutz',
    1: 'Feuerschutz',
    2: 'Federfall',
    3: 'Explosionsschutz',
    4: 'Schusssicher',
    5: 'Atmung',
    6: 'Wasserläufer',
    7: 'Dornen',
    8: 'Tiefenschreiter',
    16: 'Schärfe',
    17: 'Bann',
    18: 'Nemesis der Gliderfüßer',
    19: 'Rückstoß',
    20: 'Verbrennung',
    21: 'Plünderung',
    32: 'Effizienz',
    33: 'Behutsamkeit',
    34: 'Haltbarkeit',
    35: 'Glück',
    48: 'Stärke',
    49: 'Schlag',
    50: 'Flamme',
    51: 'Unendlichkeit',
    61: 'Glück des Meeres',
    62: 'Köder',
};

const EN: Record<number, string> = {
    0: 'Protection',
    1: 'Fire Protection',
    2: 'Feather Falling',
    3: 'Blast Protection',
    4: 'Projectile Protection',
    5: 'Respiration',
    6: 'Aqua Affinity',
    7: 'Thorns',
    8: 'Depth Strider',
    16: 'Sharpness',
    17: 'Smite',
    18: 'Bane of Arthropods',
    19: 'Knockback',
    20: 'Fire Aspect',
    21: 'Looting',
    32: 'Efficiency',
    33: 'Silk Touch',
    34: 'Unbreaking',
    35: 'Fortune',
    48: 'Power',
    49: 'Punch',
    50: 'Flame',
    51: 'Infinity',
    61: 'Luck of the Sea',
    62: 'Lure',
};

export function getEnchantmentName(id: number, lang: string = 'en'): string {
    const map = lang.startsWith('de') ? DE : EN;
    return map[id] ?? `Enchantment #${id}`;
}

export const ENCHANTMENT_IDS: number[] = Object.keys(EN).map(Number);

const ROMAN: Record<number, string> = {
    1: 'I', 2: 'II', 3: 'III', 4: 'IV', 5: 'V',
    6: 'VI', 7: 'VII', 8: 'VIII', 9: 'IX', 10: 'X',
};

export function formatEnchantmentLevel(level: number): string {
    if (ROMAN[level]) return ROMAN[level];
    return String(level);
}
